export const config ={
    baseUrl: 'https://catalogapi.hulsecure.in', 
}